import React from "react";

export default function SubjectDropdown({
  value,
  onChange,
  required = false,
  showLabel = true,
  error,
}) {
  const subjects = [
    "Mathematics",
    "English Language",
    "Physics",
    "Chemistry",
    "Biology",
    "Economics",
    "Government",
    "Literature-in-English",
    "Computer Science",
    "Agricultural Science",
    "Christian Religious Studies (CRS)",
    "Islamic Religious Studies (IRS)",
    "Physical and Health Education",
    "Geography",
    "History",
    "Financial Accounting",
    "Commerce",
    "Fine Arts",
    "Technical Drawing",
    "Music",
    "French",
    "Arabic",
    "Home Economics",
    "Social Studies",
  ];

  return (
    <div className="mb-4">
      {/* Show label only when showLabel === true */}
      {showLabel && (
        <label className="block font-medium mb-1">
          Subject of Expertise{" "}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-green-400 focus:border-green-400 outline-none transition ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        {/* Adjust placeholder text depending on label visibility */}
        <option value="">{showLabel ? "Select Subject" : "Subject"}</option>

        {subjects.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
